import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AppButtonComponent } from '../../core/ui';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-placeholder',
  standalone: true,
  imports: [AppButtonComponent, TranslateModule],
  templateUrl: './placeholder.component.html',
  styleUrl: './placeholder.component.scss'
})
export class PlaceholderComponent {
  @Input() title!: string;
  @Input() subTitle!: string;
  @Input() icon!: string;
  @Input() buttonLabel!: string;
  // @Input() iconBgColor: 'light-grey' | 'light-red' = 'light-grey';
  @Input() showButton: 'true' | 'false' = 'true';

  @Output() action = new EventEmitter<void>();

  onAction() {
    this.action.emit();
  }
}
